import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class AlcmeonNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the generateCodeForAlcmeon global action. */
    this.generateCodeForAlcmeon = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "generateCodeForAlcmeon",
      operationName: "generateCodeForAlcmeon",
      operationReturnType: "AlcmeonGenerateCodeForAlcmeon",
      namespace: "alcmeon",
      variables: {}
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "alcmeon",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  AlcmeonNamespace
};
//# sourceMappingURL=alcmeon.js.map
